var _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRrDesktopBottomCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 138,
    viewBox: "0 0 110 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 68.299,
    cy: 68.9533,
    r: 56.3764,
    transform: "rotate(168.442 68.299 68.9533)",
    stroke: "#010069",
    strokeOpacity: 0.1,
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 73.7856,
    cy: 72.5768,
    r: 51.727,
    transform: "rotate(168.442 73.7856 72.5768)",
    stroke: "#010069",
    strokeOpacity: 0.1,
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 78.4575,
    cy: 75.9641,
    r: 47.4723,
    transform: "rotate(168.442 78.4575 75.9641)",
    stroke: "#010069",
    strokeOpacity: 0.1,
    strokeWidth: 3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.1001,
    cy: 79.0301,
    r: 43.5382,
    transform: "rotate(168.442 83.1001 79.0301)",
    stroke: "#010069",
    strokeOpacity: 0.1,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRrDesktopBottomCircles);
export default __webpack_public_path__ + "static/media/RR-desktopBottomCircles.331c2a9bfd75e6d12a6069a04cd5d426.svg";
export { ForwardRef as ReactComponent };